export default __webpack_public_path__ + "static/media/TopicTip_UpgradeGIFs.b756b0d0.svg";